<app-modal-header [isShowCloseBtn]="isShowCloseBtn" (closeModal)="dismiss()"></app-modal-header>
<div class="container-fluid p-0">
  @if (loadState() === 'loading') {
    <div class="bm-loading text-center py-5" aria-live="polite" aria-busy="true">
      <span class="spinner-border" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">{{ 'LOADING' | translate }}</span>
    </div>
  }
  @if (loadState() === 'failed') {
    <div class="bm-error text-center py-4">
      <p class="mb-3">{{ 'SOMETHING_WENT_WRONG' | translate }}</p>
      <button type="button" class="btn btn-primary rounded-5" (click)="retryLoad()">
        {{ 'RETRY' | translate }}
      </button>
    </div>
  }
  <div class="bm-wrapper" #businessMatchingContainer></div>
</div>
